
import React, { useEffect, useState } from 'react';
import Api from '../../shared/AApi';
import { ApiEndpoints } from '../../shared/Common';
import { useTranslation } from "react-i18next";
import EqHorsesTaskList from '../../custom/eqHorsesTaskList/EqHorsesTaskList';
import { Col, Empty, notification, Row, Skeleton } from 'antd';
import { EqHorseTrainingType, eqLoadingState, eqNotificationTypes, EqTaskTypes } from '../../shared/enums';
import './TrainerHorseActivity.scss';
import { useNavigate } from 'react-router-dom';
import { EqUiHorse, EqUiHorseTask, EqUiHorseTraining } from '../../shared/interfaces/horse/IHorses';
import { HorseActivity } from '../../custom/eqHorseTaskBoard/EqHorseTaskBoard';

const HorseUpcomingAct = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(eqLoadingState.initial);
    const [horsesDataListFormatted, setHorsesDataListFormatted] = useState({} as any);

    const navigate = useNavigate();

    const getHorseList = () => {
        setLoading(eqLoadingState.loading);

        Api.get(ApiEndpoints.horse.getAllHorsesIncluded).then(
            (response: any) => {
                setLoading(eqLoadingState.loadingCompleted);
                if (response && response.status === 200) {
                    let data:EqUiHorse[]=response.data
                    
                    var formattedData = formatHorseListWithActivities([...data]);
                    const sortedData = formattedData.sort((a, b) => b.time - a.time);
                   
                    setHorsesDataListFormatted({ allData: [...sortedData], filteredData: [...sortedData], apiData: [...response.data] });
                } else {
                    console.error('Error fetching horse list');
                }
            },
            (error) => {
                setLoading(eqLoadingState.loadingCompleted);
                console.error('Error fetching horse list', error);
            }
        );
    };

    const formatHorseListWithActivities = (data: EqUiHorse[]): HorseActivity[] => {
        const output: HorseActivity[] = [];
        data.forEach(hrs => {
            hrs.horseTasks.forEach(ht => {
                output.push(mapActivity(hrs, 1, ht));
            });

            hrs.horseTrainings.forEach(ht => {
                output.push(mapActivity(hrs, 2, ht));
            });
        });
        return output;
    };
 const isTraining = (ht: EqUiHorseTask | EqUiHorseTraining): ht is EqUiHorseTraining => {
        return (ht as EqUiHorseTraining).trainingType !== undefined;
    };

  const mapActivity = (hrs: EqUiHorse, activityType: number, ht: EqUiHorseTask | EqUiHorseTraining): HorseActivity => {
        return {
            id: hrs.id,
            key: hrs.key || '',
            activityKey: ht.key || '',
            activityId: ht.id,
            name: hrs.name,
            imageUrl: hrs.imageUrl || '',
            task: isTraining(ht) 
            ? String(EqHorseTrainingType[ht.trainingType]) 
            : String(EqTaskTypes[ht.taskType]),  // Explicitly cast to string
            activityType,
            time: ht.time,
            duration: isTraining(ht) ? ht.durationInMinutes : "",
            notificationTime: ht.notificationTime,
            status: Number(ht.status) || 0,
            isEditing: false
        };
    };

    useEffect(() => {
        getHorseList();
    }, []);
    const removeItemOnDelete = (val: any) => {
        var updatedList = { ...horsesDataListFormatted }

        var index = updatedList.allData.findIndex((d: any) => d.activityKey == val.activityKey);
        updatedList.allData.splice(index, 1);

        index = updatedList.filteredData.findIndex((d: any) => d.activityKey == val.activityKey);
        updatedList.filteredData.splice(index, 1);
        setHorsesDataListFormatted(updatedList)

    };

    const openNotificationWithIcon = (
        msg: any,
        desc: any,
        type = eqNotificationTypes.error
    ) => {
        if (type == eqNotificationTypes.success) {
            notification["success"]({
                message: msg,
                description: desc,
            });
        } else if (type == eqNotificationTypes.info) {
            notification["info"]({
                message: msg,
                description: desc,
            });
        } else {
            notification["error"]({
                message: msg,
                description: desc,
            });
        }
    };
    const eqHorsesTaskListProps: any = {
        horsesTaskList: horsesDataListFormatted,
        delFunc: (val: any) => {
            console.log(val);
            var objToSend: any = {
                key: val.activityKey,
                date: val.time,
                time: val.time,
                description: "",
                notificationTime: val.notificationTime,
                horseId: val.id
            }

            if (val.activityType == 1) { //delete horse task                
                objToSend.taskType = EqTaskTypes[val.task]
                Api.post(ApiEndpoints.horse.task.delete, objToSend).then((response: any) => {

                    removeItemOnDelete(val);


                    openNotificationWithIcon(t('update'), t('horseTaskDeleteTxt'), eqNotificationTypes.success)
                }, error => {
                    console.log(error)
                    openNotificationWithIcon(t('update'), t('horseTaskErrorTxt'), eqNotificationTypes.error)
                })
            } else { // horse training deleted
                objToSend.trainingType = EqHorseTrainingType[val.task]
                objToSend.durationInMinutes = val.duration != "" ? val.duration : 0;

                Api.post(ApiEndpoints.horse.training.delete, objToSend).then((response: any) => {

                    removeItemOnDelete(val);


                    openNotificationWithIcon(t('update'), t('horseTrainingDeleteTxt'), eqNotificationTypes.success)
                }, error => {
                    openNotificationWithIcon(t('update'), t('horseTaskErrorTxt'), eqNotificationTypes.error)
                })
            }
        },
        editFunc: (val: any) => {
            console.log(horsesDataListFormatted, "horsesDataListFormatted");
        },
        selectedFunc: (val: any) => {
            // Handle selection if needed
        }
    };

    return (
        <div className="horse-management-dashboard">

            <div className="top-heading-div">
                <h3>{t("horseActivities")}</h3>
                <h3 onClick={() => navigate("/trainer/taskList")}  className="Training-button">
                    {t("seeAllActivities")}
                </h3>
            </div>
            <div className="loading">
                <Skeleton loading={loading === eqLoadingState.loading} active></Skeleton>
            </div>
                    <Row className="header-Row hidden-sm" gutter={[0, 0]}>
                        <Col className="eq-fl-th" span={5}>
                            {t("name")}
                        </Col>
                        <Col className="eq-fl-th" span={3}>
                            {t("activity")}
                        </Col>
                        <Col className="eq-fl-th" span={3}>
                            {t("time")}
                        </Col>
                        <Col className="eq-fl-th" span={3}>
                            {t("duration")}
                        </Col>
                        <Col className="eq-fl-th" span={2}>
                            {t("type")}
                        </Col>
                        <Col className="eq-fl-th" span={3}>
                            {t("notifications")}
                        </Col>
                        <Col className="eq-fl-th" span={4}>
                            {t("status")}
                        </Col>
                        <Col className="eq-fl-th" span={1}>
                            {t("action")}
                        </Col>
                    </Row>
                {loading === eqLoadingState.loadingCompleted && horsesDataListFormatted?.filteredData?.length ? (
                    <EqHorsesTaskList {...eqHorsesTaskListProps} horsesTaskList={{
                        allData: horsesDataListFormatted.allData,
                        filteredData: horsesDataListFormatted.filteredData.slice(0, 4),
                        apiData: horsesDataListFormatted.apiData
                    }} />
                ) : (
                    <div className="no-data">
                        <Empty description={t("noDataAvailable")} />
                    </div>
                )}

            </div>
    );
};

export default HorseUpcomingAct;